(() => {
  const root = document.documentElement;
  const headerSelector = '.shopify-section-group-header-group';
  let sections = [];
  let frame = 0;
  let previousTop = -1;

  const update = () => {
    let bottom = 0;
    sections.forEach((section) => {
      const rect = section.getBoundingClientRect();
      if (rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight) {
        bottom = Math.max(bottom, rect.bottom);
      }
    });
    const top = Math.min(window.innerHeight, Math.max(0, Math.ceil(bottom)));
    if (top !== previousTop) {
      root.style.setProperty('--akuma-overlay-top', `${top}px`);
      previousTop = top;
    }
  };

  const tick = () => {
    frame = 0;
    update();
    // Track sticky-header transitions and browser chrome while a window is open.
    if (document.querySelector('cart-drawer.active, product-modal[open]')) schedule();
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(tick);
  };
  const resizeObserver = new ResizeObserver(schedule);
  const refresh = () => {
    resizeObserver.disconnect();
    sections = [...document.querySelectorAll(headerSelector)];
    sections.forEach((section) => resizeObserver.observe(section));
    update();
    schedule();
  };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  // Measure before click handlers open a drawer or media modal.
  document.addEventListener('click', update, true);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);
  new MutationObserver(schedule).observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'open'],
  });
  refresh();
})();
